import { Component } from 'react';

export class GeolocationHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      latitude: null,
      longitude: null,
    };
    this.intervaloId = null;  // Para almacenar el ID del intervalo
  }

  // Método para obtener la ubicación
  getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.setState({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          localStorage.setItem('latitude', position.coords.latitude);
          localStorage.setItem('longitude', position.coords.longitude);          
        },
        (error) => {
          console.info("Error al obtener la ubicación:", error);
        }
      );
    } else {
      console.log("La geolocalización no es compatible con este navegador.");
    }
  };

  // Inicializa el servicio y el intervalo
  componentDidMount() {
    this.getLocation();  // Obtener la ubicación al montar el componente
    this.intervaloId = setInterval(this.getLocation, 20000); // Actualizar cada 20 segundos
  }

  // Limpia el intervalo al desmontar el componente
  componentWillUnmount() {
    clearInterval(this.intervaloId);
  }

  render() {
    return null;  // Este componente no necesita renderizar nada
  }
}

export default GeolocationHandler;
